var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-row',_vm._l((_vm.LIST_NAME),function(card){return _c('a-col',{key:card.name,attrs:{"span":12}},[_c('CardListUser',{attrs:{"name":card.name,"card-title":card.title}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }